import { forwardRef, type Ref, type SVGProps } from "react";

function SvgClipboardScoreCancellationColored(
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) {
  return (
    <svg ref={ref} viewBox="0 0 80 83" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M30.9404 4.65234C35.9425 -0.477771 44.0575 -0.477771 49.0596 4.65234L49.9824 5.59863C52.1974 7.87045 55.1993 9.1444 58.3262 9.14453H58.5615C65.646 9.14453 71.3681 15.0317 71.3682 22.2666V22.5078C71.3682 25.7267 72.6155 28.8116 74.8311 31.084L75.7539 32.0303C80.7491 37.1536 80.7491 45.4558 75.7539 50.5791L74.8311 51.5254C72.6155 53.7978 71.3682 56.8826 71.3682 60.1016V60.3428C71.3681 67.5776 65.646 73.4648 58.5615 73.4648H58.3262C55.1993 73.465 52.1974 74.7389 49.9824 77.0107L49.0596 77.957C44.0575 83.0871 35.9425 83.0871 30.9404 77.957L30.0176 77.0107C27.8025 74.7389 24.8007 73.465 21.6738 73.4648H21.4385C14.354 73.4648 8.63195 67.5776 8.63184 60.3428V60.1016C8.63184 56.8826 7.3845 53.7978 5.16895 51.5254L4.24609 50.5791C-0.749132 45.4558 -0.749132 37.1536 4.24609 32.0303L5.16895 31.084C7.3845 28.8116 8.63184 25.7267 8.63184 22.5078V22.2666C8.63194 15.0317 14.354 9.14453 21.4385 9.14453H21.6738C24.8007 9.1444 27.8026 7.87045 30.0176 5.59863L30.9404 4.65234Z"
        fill="url(#paint0_linear_100_6573)"
        stroke="#FFB7B7"
      />
      <path
        d="M46.3029 27.7692C48.2067 25.8165 51.2926 25.8165 53.1964 27.7692C55.1002 29.7218 55.1002 32.8868 53.1964 34.8395L46.8932 41.3043L53.1964 47.7692L53.531 48.1486C55.0929 50.1125 54.9813 53.0088 53.1964 54.8395C51.4115 56.6701 48.5876 56.7845 46.6728 55.1827L46.3029 54.8395L39.9996 48.3746L33.6964 54.8395C31.7926 56.7921 28.7067 56.7921 26.8029 54.8395C24.899 52.8868 24.899 49.7218 26.8029 47.7692L33.1061 41.3043L26.8029 34.8395C24.899 32.8868 24.899 29.7218 26.8029 27.7692C28.7067 25.8165 31.7926 25.8165 33.6964 27.7692L39.9996 34.234L46.3029 27.7692Z"
        fill="url(#paint1_linear_100_6573)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_100_6573"
          x1="22.45"
          y1="1.30469"
          x2="40.8654"
          y2="81.105"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F1F2E8" />
          <stop offset="1" stopColor="#F7D0D0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_100_6573"
          x1="39.9996"
          y1="31.3043"
          x2="39.9996"
          y2="51.3043"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#82090F" />
          <stop offset="1" stopColor="#B0676A" />
        </linearGradient>
      </defs>
    </svg>
  );
}

const ForwardRef = forwardRef(SvgClipboardScoreCancellationColored);
export default ForwardRef;
